import store from '../redux/store';

export const spinnerShow = () => {
  store.dispatch({ type: 'spinner', response: true });
}

export const spinnerHideDelayed = () => {
  setTimeout(() => {
    store.dispatch({ type: 'spinner', response: false });
  }, 1000);
}

export const spinnerHide = () => {
  store.dispatch({ type: 'spinner', response: false });
}

export const closeSpinner = () => {
  spinnerHide();
}